<template>
  <div class="cmp-product-documents utlz-row">
    <div class="utlz-col-12">
      <ul>
        <li v-for="(document, index) in documents" :key="index">
          <!-- BESPOKE DUTCH-83: Add the option to download documents from bytearrays -->
          <template v-if="document.docContent.length == 0">
            <a class="text-link" :href="document.fileLocation" target="_blank">
              <i class="fa fa-file-text-o"></i>
              <span>{{ document.description }}</span>
            </a>
          </template>

          <template v-else>
            <a class="text-link" :href="getFileUrl(document.docContent)" target="_blank">
              <i class="fa fa-file-text-o"></i>
              <span>{{ document.description }}</span>
            </a>
          </template>
          <!-- END BESPOKE DUTCH-83 -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    documents: { type: Array, required: true }
  },
  // BESPOKE DUTCH-83
  methods: {
    getFileUrl(documentByteArray) {
      var arrayBuffer = new Uint8Array(documentByteArray).buffer;
    var blob = new Blob([arrayBuffer], { type: 'application/pdf' });
      return URL.createObjectURL(blob);
    }
    // END BESPOKE DUTCH-83
  }
}
</script>

<style>

</style>
